import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { AbstractModuleUi } from '../_abstract/ui';
let HeadingNavModuleUi = class HeadingNavModuleUi extends AbstractModuleUi {
    get processedHeading() {
        if (!this.module.content.heading) {
            return '';
        }
        // Process *text* with regex like in Presentation module
        return this.module.content.heading.replace(/\*([^*]+)\*/g, '<span>$1</span>');
    }
    get hasMenuItems() {
        return this.module.content.menu && this.module.content.menu.length > 0;
    }
    get menuVariantClass() {
        return `--${this.module.content.menuVariant}`;
    }
    /**
     * Handles menu clicks. For in-page hash links, prevent default and scroll with sticky offset.
     */
    onMenuClick(item, event) {
        const url = (item && item.url) || '';
        // Allow default navigation for non-hash or external links, or when opening in a new tab/window.
        if (!url.startsWith('#') || (item && item.newWindow)) {
            return;
        }
        event.preventDefault();
        const hash = url;
        const targetId = hash.replace(/^#/, '');
        const target = document.getElementById(targetId);
        // Update the URL hash without adding a new history entry.
        try {
            const { pathname, search } = window.location;
            window.history.replaceState(null, document.title, `${pathname}${search}${hash}`);
        }
        catch (e) {
            // noop
        }
        if (!target) {
            return;
        }
        // Compute sticky navbar offset (from CSS var if present), fallback to a reasonable default.
        const offset = this.getNavbarOffsetPx();
        // Scroll to the element, accounting for the sticky header height.
        const targetTop = window.pageYOffset + target.getBoundingClientRect().top - offset;
        window.scrollTo({ top: targetTop, behavior: 'smooth' });
    }
    getNavbarOffsetPx() {
        const root = document.documentElement;
        const raw = getComputedStyle(root).getPropertyValue('--navbar-height').trim();
        // Expect a value like "80px"; parseInt will extract the numeric part.
        const parsed = raw ? parseInt(raw, 10) : NaN;
        return Number.isFinite(parsed) && parsed > 0 ? parsed : 124;
    }
};
HeadingNavModuleUi = __decorate([
    Component({
        name: 'HeadingNavModuleUi',
        template: `
    <section class="heading-nav-module" :class="[themeClass, sizeClass, debugClass]">
      <div class="container">
        <div class="heading-nav-module__content">
          <component
            v-if="module.content.heading"
            :is="module.content.headingType"
            class="heading-nav-module__heading"
            v-html="processedHeading"
          />
          <nav v-if="hasMenuItems" class="heading-nav-module__nav" :class="menuVariantClass">
            <ul class="heading-nav-module__menu">
              <li v-for="(item, index) in module.content.menu" :key="index" class="heading-nav-module__menu-item">
                <a
                  v-if="item.url"
                  :href="item.url"
                  :target="item.newWindow ? '_blank' : '_self'"
                  :rel="item.newWindow ? 'noopener noreferrer' : ''"
                  class="heading-nav-module__menu-link"
                  @click="onMenuClick(item, $event)"
                >
                  {{ item.label }}
                </a>
                <span v-else class="heading-nav-module__menu-text">
                  {{ item.label }}
                </span>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </section>
  `
    })
], HeadingNavModuleUi);
export { HeadingNavModuleUi };
